import { useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { startCheckout } from "@/lib/checkout";
import { PRODUCT } from "@/constants/product";

const inputCls = "mt-1.5 w-full rounded-md border border-black/20 bg-white px-4 py-3 text-[var(--ink)] outline-none transition-colors focus:border-[var(--sage-deep)]";

const Field = ({ label, testId, ...props }) => (
  <label className="block text-sm font-medium">
    {label}
    <input className={inputCls} data-testid={testId} {...props} />
  </label>
);

const EMPTY = { recipient_name: "", recipient_email: "", sender_name: "", message: "" };

export const GiftDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await startCheckout(form);
    if (!ok) setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] max-w-md overflow-y-auto border-black/20 bg-[var(--paper)]" data-testid="gift-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl">Send it as a gift</DialogTitle>
          <DialogDescription className="text-[var(--muted)]">After you pay, we'll email your friend a link to download the workbook. {PRODUCT.price}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="gift-form">
          <Field label="Friend's name" required maxLength={60} value={form.recipient_name} onChange={set("recipient_name")} testId="gift-recipient-name-input" />
          <Field label="Friend's email" type="email" required value={form.recipient_email} onChange={set("recipient_email")} testId="gift-recipient-email-input" />
          <Field label="Your name" required maxLength={60} value={form.sender_name} onChange={set("sender_name")} testId="gift-sender-name-input" />
          <label className="block text-sm font-medium">
            Message <span className="font-normal text-[var(--muted)]">(optional)</span>
            <textarea rows={3} maxLength={300} value={form.message} onChange={set("message")} className={`${inputCls} resize-none`} placeholder="Happy meal planning!" data-testid="gift-message-input" />
          </label>
          <button disabled={busy} className="btn-ink flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 font-semibold disabled:opacity-70" data-testid="gift-submit-button">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Gift className="h-4 w-4" />} Continue to payment
          </button>
          <p className="text-center text-xs text-[var(--muted)]">You'll get a receipt by email. Your friend gets the download link.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
};
